import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './statCard.css';

/**
 * StatCard - Reusable metric display card
 * @param {string|Array} icon - FontAwesome icon
 * @param {string|number} value - The metric value
 * @param {string} label - Description label
 * @param {string} variant - 'default' | 'accent' | 'success' | 'warning' | 'error' | 'info'
 * @param {string} size - 'default' | 'lg'
 * @param {string} subtitle - Optional secondary text
 * @param {string} className - Additional class names
 */
export default function StatCard({ icon, value, label, variant = 'default', size = 'default', subtitle, className = '' }) {
  return (
    <div className={`sc-card sc-${variant} sc-size-${size} ${className}`.trim()}>
      {icon && (
        <div className="sc-icon">
          <FontAwesomeIcon icon={icon} />
        </div>
      )}
      <div className="sc-body">
        <div className="sc-value">{value}</div>
        <div className="sc-label">{label}</div>
        {subtitle && <div className="sc-subtitle">{subtitle}</div>}
      </div>
    </div>
  );
}
